import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            <ScrollAnimation animateIn="fadeInLeft">
              <img
                src="./img/Services/about.png"
                className="img-responsive"
                alt=""
              />
            </ScrollAnimation>
          </div>

          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>About Us</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3 style={{ color: "orange" }}>What We Do?</h3>
              <p>{props.data ? props.data.whatwedo : "loading..."}</p>
              <h3 style={{ color: "orange" }}>Why Choose Us?</h3>
              <ScrollAnimation animateIn="fadeInRight" delay={0.6 * 1000}>
                <div className="list-style">
                  <div className="col-lg-6 col-sm-6 col-xs-12">
                    <ul>
                      {props.data
                        ? props.data.Why.map((d, i) => (
                            <li key={`${d}-${i}`}>{d}</li>
                          ))
                        : "loading"}
                    </ul>
                  </div>

                  <div className="col-lg-6 col-sm-6 col-xs-12">
                    <ul>
                      {props.data
                        ? props.data.Why2.map((d, i) => (
                            <li key={`${d}-${i}`}> {d}</li>
                          ))
                        : "loading"}
                    </ul>
                  </div>
                </div>
              </ScrollAnimation>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
